module.exports = __webpack_public_path__ + "static/img/bg31.8787bc79.png";